@let userMeta = userMetaViewModel();

@if (userMeta) {
  @if (userMeta.isConnected) {
    <div class="si-dialog-user-meta">
      <div class="si-dialog-user-meta__avatar" aria-hidden="true">{{ userMeta.initials }}</div>

      <div class="si-dialog-user-meta__details">
        <div class="si-dialog-user-meta__summary">
          <span class="si-dialog-user-meta__name">{{ userMeta.displayName }}</span>

          @if (userMeta.email) {
            <span class="si-dialog-user-meta__email">({{ userMeta.email }})</span>
          }
        </div>
      </div>
    </div>
  } @else {
    <div class="si-dialog-user-meta si-dialog-user-meta--disconnected">
      <div class="si-dialog-user-meta__status">{{ userMeta.displayName }}</div>
    </div>
  }
}
